import { render, staticRenderFns } from "./CookiesControl.vue?vue&type=template&id=52cd38eb&scoped=true"
import script from "./CookiesControl.vue?vue&type=script&lang=ts"
export * from "./CookiesControl.vue?vue&type=script&lang=ts"
import style0 from "./CookiesControl.vue?vue&type=style&index=0&id=52cd38eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cd38eb",
  null
  
)

export default component.exports